import React from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'

const ModalInfo = props => (
  <Modal
    isOpen={props.isOpen}
    onRequestClose={props.close}
    contentLabel="Modal"
    ariaHideApp={false}
  >
    <p className="close-modal" onClick={props.close}>
      Close<i className="fa fa-times"></i>
    </p>
    <div className="modal-board">
      <h4>{props.title}</h4>
      <p className={props.error ? 'error' : ''}>{props.info}</p>
    </div>
  </Modal>
)

ModalInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  error: PropTypes.bool,
}

export default ModalInfo
